import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

const StudentPartnerInfo = () => {
  const { t, lang } = useTranslation('student');

  return (
    <div className="mt-4 border-t border-solid border-surface-100-hairline px-5 py-6 text-center">
      <div className="enki-body-sm-medium text-surface-100-fg-default">{t('partner_with_us')}</div>
      <ul className="enki-body-2xs text-surface-100-fg-minor">
        <li className="mt-2">
          <Trans
            i18nKey="student:partner_contact_1"
            components={{
              email: <a href="mailto:Students@sayweee.com" className="text-secondary-base-1"></a>
            }}
          />
        </li>
        <li className="mt-2">
          <Trans
            i18nKey="student:partner_contact_2"
            components={{
              a: (
                <a
                  href={`https://www.sayweee.com/company/affiliates-${lang}?pushto=native&__show_header__=2`}
                  className="text-secondary-base-1"></a>
              )
            }}
          />
        </li>
      </ul>
      <div className="mt-5 enki-body-3xs text-btn-disabled-fg-minor inline-flex items-center justify-center">
        <a href={`/${lang}/help/detail/2681?pushto=native`} className="text-btn-disabled-fg-minor">
          {t('student_discount_program_terms')}
        </a>
        <span className="mx-2 font-extrabold">·</span>
        <a href={`/${lang}/about/terms-of-service?pushto=native`} className="text-btn-disabled-fg-minor">
          {t('terms_and_conditions')}
        </a>
      </div>
    </div>
  );
};

export default StudentPartnerInfo;
